export function getCurrentTime() {
  let currentDate = new Date(); //local time with UTC mark
  return currentDate; //return UTC time
}
